import { fetch } from '@atlassian/eoc-fetch';

import type {
	AvailableIntegration,
	GetIntegrationListResponse,
	GetIntegrationTypeResponse,
	IntegrationLabels,
	IntegrationType,
} from '../../../common/types/integration-list';
import { UrlHelper } from '../../../common/utils/url-helper';

import type { IntegrationTypes } from './types';

const getIntegrationList = (
	query?: Record<string, string>,
	teamId?: string | null,
): Promise<{
	allTypes: AvailableIntegration[];
	availableGroups: IntegrationType[];
	labels: IntegrationLabels[];
	platformTeamId: string | undefined;
}> => {
	const { keyword, group } = query ?? {};

	return fetch<GetIntegrationListResponse>(
		UrlHelper(`/v3/integrations/unified/supported-integrations`, {
			keyword,
			group,
			teamId,
		}),
	).then((response) => {
		const { labels, availableGroups, allTypes, platformTeamId } = response.data;
		return { labels, availableGroups, allTypes, platformTeamId };
	});
};

const getIntegrationTypes = (integrationType: string, teamId?: string): Promise<IntegrationTypes> =>
	fetch<GetIntegrationTypeResponse>(
		UrlHelper(`/v3/integrations/unified/${integrationType}/types`, {
			teamId,
		}),
	).then((response) =>
		response.data.map((integrationType) => ({
			...integrationType,
			value: integrationType.type,
			label: integrationType.displayName,
		})),
	);

const _default_1: {
	getIntegrationList: (
		query?: Record<string, string>,
		teamId?: string | null,
	) => Promise<{
		allTypes: AvailableIntegration[];
		availableGroups: IntegrationType[];
		labels: IntegrationLabels[];
		platformTeamId: string | undefined;
	}>;
	getIntegrationTypes: (integrationType: string, teamId?: string) => Promise<IntegrationTypes>;
} = {
	getIntegrationList,
	getIntegrationTypes,
};
export default _default_1;
